import { JsonSchema } from '@sagold/react-json-editor';

/** Creatable selects use suggestions (not schema.enum) and only load options once. */
export function isCreatableSuggestionsSchema(schema: JsonSchema): boolean {
  return schema.format === 'creatable-select';
}

/**
 * Fields excluded from the conditional-filter request payload.
 * Creatable selects are skipped by format; other fields can opt out via options.skipInFilter.
 */
export function shouldSkipInConditionalFilter(schema: JsonSchema): boolean {
  return (
    isCreatableSuggestionsSchema(schema) ||
    schema.options?.skipInFilter === true
  );
}
